<div class="top-menu">
  <div class="side-menu"><img class="menu-icon" src="/assets/icons/menu-24.svg" (click)="menuClick()" /></div>
  <div class="logo-wrap"><img class="shaleapps-icon" src="/assets/icons/logo.svg" /></div>
  <div class="account-name">
    {{ userLabel.email || userLabel.name || 'Unknown' }}
  </div>
</div>
